import script from "./ExportLessonPdf.vue?vue&type=script&setup=true&lang=js"
export * from "./ExportLessonPdf.vue?vue&type=script&setup=true&lang=js"

import "./ExportLessonPdf.vue?vue&type=style&index=0&id=1fb1273e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1fb1273e"]])

export default __exports__